import { PlatformBadge } from "@/components/PlatformBadge";
import type { Channel } from "@/lib/api";

// DormancyBadge — the "沉睡 N天 / ∞" pill shown when a channel has had no content
// in the dormancy window (computeDormancyDays returns non-null; 999 = never had
// content). Extracted from Channels.tsx (Phase 4d) as a reusable domain badge.
export function DormancyBadge({ days }: { days: number }) {
  return (
    <span
      className="rounded bg-zinc-200 px-1.5 py-0.5 text-[10px] font-medium text-zinc-600"
      title="该频道最近 90 天没有新内容，所有 90d 指标会为空"
    >
      沉睡 {days >= 999 ? "∞" : `${days}天`}
    </span>
  );
}

// ChannelNameCell — the 频道库 name column: display name + optional dormancy
// badge, with the handle + platform badge underneath. Extracted verbatim from
// Channels.tsx's row map (Phase 4d) behind the full-page snapshot; renders a
// fragment so the host <TD> + column-visibility conditional stay in the page.
export function ChannelNameCell({
  channel: c,
  dormantDays,
}: {
  channel: Channel;
  dormantDays: number | null;
}) {
  return (
    <>
      <div className="flex items-center gap-2">
        <span className="font-medium">{c.Name ?? c.Handle ?? c.PlatformChannelID}</span>
        {dormantDays !== null && <DormancyBadge days={dormantDays} />}
      </div>
      <div className="text-xs text-muted-foreground inline-flex items-center gap-1.5">
        <span>{c.Handle ?? c.PlatformChannelID}</span>
        <PlatformBadge platform={c.Platform} />
      </div>
    </>
  );
}
